<script setup lang="ts">
/**
 * Module: web/src/layouts/BareLayout.vue
 * Author: Salvo Praxis (w/ AI pair programming partner Claude Code by Anthropic)
 * Version: 1.0.0
 * Date: 2026-07-08
 *
 * Chrome-less layout for the auth surfaces (login / PIN / reset) and the
 * PIN quick shell -- those views carry their own minimal chrome.
 */
</script>

<template>
  <div class="min-h-screen bg-bg text-fg">
    <slot />
  </div>
</template>
